import React from 'react';

const EventBox = ( { event, renderRegistrationLink } ) => {
	if ( event.is_featured ) {
		return null;
	}

	return (<div className="events-post col-sm-12 col-md-6 col-lg-3"
	             data-region={ event.region }>
			<div className="events-post-wrapper">
				<div className="date-bookmark-container">
					<p className="events-post-date">{ event.formatted_date }</p>
					<div className="bookmark-container">
						<div className="bookmark">
							<i
								className={ `fa-bookmark ${ ISDA_Main.userBookmarks.includes( event.id )
								                            ? 'fa'
								                            : 'fa-regular' } toggle-bookmark` }
								data-post-id={ event.id }
							></i>
						</div>
					</div>
				</div>
				<p className="events-post-location">
					{ !event.is_hybrid ? (
						<a href={ event.city_link }>{ event.city.name }</a>
					) : (
						  <a href={ event.city_link }>{ event.city.name }/Online</a>
					  ) }
				</p>
				<h2 className="events-post-title">
					<a href={ event.link } data-imiscode={ event.imis_code }>
						{ event.title }
					</a>
				</h2>
				<div className="events-post-img-wrap">
					<a href={ event.link } data-imiscode={ event.imis_code }>
						<img
							src={ event.thumbnail }
							className="event-venue-thumbnail"
							alt=""
							role="presentation"
							width="336"
							height="297"
						/>
					</a>
				</div>
				<div className="events-post-buttons">
					<a
						href={ event.link }
						className="btn btn-default outlined"
						data-imiscode={ event.imis_code }
					>
						Details
						<span className="sr-only"> for { event.title }</span>
					</a>
					{ renderRegistrationLink( event ) }
				</div>
			</div>
		</div>
	);
};

EventBox.defaultProps = {
	renderRegistrationLink: () => null
};

export default EventBox;
